module.exports = __webpack_public_path__ + "static/media/omni.774e137a.svg";